import React from 'react';
const reviews = [{
  quote: '„Meine Hündin hatte seit 2021 Bauchschmerzen, Durchfall und Sodbrennen. Nichts half. Seit dem Topping ist sie beschwerdefrei und glücklich – und ich als Halterin noch mehr. Danke, Hunderunde!"',
  author: 'Angela & Layla'
}, {
  quote: '„Meine Hündin Aika litt lange unter Sodbrennen. Nichts half – bis wir das Magen & Darm Topping ausprobierten. Nach Dosiserhöhung besserte sich alles. Wir sind überglücklich! Jetzt ist es im Sparplan."',
  author: 'Diana & Aika'
}, {
  quote: '„Seit 1 Monat bekommt sie das Magen-Darm-Topping und ist sichtbar fitter, aktiver, wacher – ohne Verdauungsprobleme. Sogar ihr wählerischer Geschmack passt. Danke!"',
  author: 'Nadja & Sonnenblume'
}];
export function ReviewCards() {
  return <>
      {reviews.map((review, index) => <div key={index} className="bg-surface border border-border rounded-[12px] px-[26px] py-[22px] my-[1.6em]" data-id="element-83">
          <div className="text-amber text-[0.95rem] tracking-[0.04em] mb-[10px]" data-id="element-84">
            ★★★★★
          </div>
          <p className="italic text-[0.93rem] text-text-mid mb-[10px] leading-[1.85]" data-id="element-85">
            {review.quote}
          </p>
          <div className="font-sans text-[0.75rem] font-semibold text-text-muted" data-id="element-86">
            — {review.author} &nbsp;·&nbsp; ✪ Verifizierter Kauf
          </div>
        </div>)}
    </>;
}